import * as React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Button } from '@mui/material';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';

const drawerBleeding = 56;

const Root = styled('div')(({ theme }) => ({
  height: '100%',
  // backgroundColor:
  //   theme.palette.mode === 'light' ? grey[100] : theme.palette.background.default,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

const Puller = styled(Box)(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === 'light' ? grey[300] : grey[900],
  // backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.main : grey[900],
  borderRadius: 3,
  position: 'absolute',
  top: 14,
  left: 'calc(50% - 15px)',
}));

function SwipeableEdgeDrawer(props) {
  const { window, text, content, sx } = props;
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // This is used only for the example
  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          '.swipeable-drawer > .MuiPaper-root': {
            height: `calc(82% - ${drawerBleeding}px)`,
            overflow: 'visible', zIndex: 111,
          },
          '.swipeable-drawer': {
            zIndex: '111 !important',
          },
          ...sx
        }}
      />
      <Box sx={{ textAlign: 'center', mt: 2.3, borderRadius: "5px", background: '#fbfbfc', }}>
        <Button
          onClick={toggleDrawer(true)}
          sx={{ width: '100%', textTransform: 'none', justifyContent: 'space-between', background: '#fbfbfc', border: "1px solid rgb(229, 234, 242)" }}
          endIcon={<ExpandCircleDownOutlinedIcon sx={{ transform: 'rotate(270deg)', opacity: .5 }} />}
        >
          {text}
        </Button>
      </Box>
      <SwipeableDrawer
        className="swipeable-drawer"
        container={container}
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {open ?
          <StyledBox
            sx={{
              position: 'absolute',
              top: open ? -drawerBleeding : 0,
              borderTopLeftRadius: 14,
              borderTopRightRadius: 14,
              visibility: 'visible',
              right: 0, pt: open ? 0 : 1,
              left: 0, zIndex: 111, boxShadow: open ? 0 : 'rgba(0, 0, 0, 0.2) 0px -3px 15px -1px, rgba(0, 0, 0, 0.14) 0px -5px 20px 0px, rgba(0, 0, 0, 0.12) 0px 0px 0px 0px',
              height: '3.5rem', background: '#fbfbfc', textAlign: 'center',
              display: { xs: 'block', sm: 'none', md: 'none', }
            }}
          >

            <Box onClick={toggleDrawer(false)} sx={{ '&:hover': { opacity: 1 }, cursor: 'pointer', transform: 'rotate(270deg)', zIndex: 111, opacity: 0.25, justifyContent: 'center', alignItems: 'center', width: '2rem', height: '72px', display: 'flex', margin: 'auto' }}>
              <div style={{ alignItems: 'center', flexDirection: 'column', width: '1.5rem', height: '2.3rem', display: 'flex' }}>
                <div style={{ transform: 'translateY(0.15rem) rotate(15deg) translateZ(0px)', backgroundColor: '#031363', borderRadius: "9999px", width: '.35rem', height: '4.75rem' }}></div>
                <div style={{ transform: 'translateY(-0.15rem) rotate(-15deg) translateZ(0px)', backgroundColor: '#031363', borderRadius: "9999px", width: '.35rem', height: '4.75rem' }}></div>
              </div>
            </Box>
            {/* : <Puller onClick={toggleDrawer(true)} />}
          {open ? null : <Typography sx={{ color: 'text.secondary', lineHeight: 4.5, fontSize: '.87rem' }}>{text}</Typography>} */}
          </StyledBox> : null}
        <StyledBox
          sx={{
            px: 2,
            pb: 2,
            height: '100%',
            overflow: 'auto',
            display: { xs: 'block', sm: 'none', md: 'none', }
          }}
        >
          {content}
        </StyledBox>
      </SwipeableDrawer>
    </Root>
  );
}

SwipeableEdgeDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default SwipeableEdgeDrawer;
